module.exports = __webpack_public_path__ + "img/1949-Groveland Four Trial.836a3600.jpg";